export default __webpack_public_path__ + "static/media/background-image-1.3cd952f6.jpg";